module.exports = __webpack_public_path__ + "img/slogo.14a6e97a.png";